import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { useNode } from '@splashthat/splash-cms-engine';
import { useTouchpointData } from 'common/components/TouchpointEditor/contexts/TouchpointDataContext';
import { getCustomCssClassName } from 'common/components/TouchpointEditor/tools/CustomCssTools/CustomCssTools';
import { DEFAULT_LOGO_IMAGE, CONTENT_TYPE_DARK_LOGO } from './constants';

import { LogoStyles } from './Logo.styles';

const BASE_CLASS_NAME = 'Logo';

const Logo = React.forwardRef(
    ({ styles: { width }, meta: { src, logoType, accessibilityText, visible }, selected, hovered }, ref) => {
        const node = useNode();
        const { theme } = useTouchpointData();

        const brandedLogo = get(theme, ['logos', logoType, 'default']);
        const logoSource = brandedLogo || src;
        const customCssClassName = getCustomCssClassName(node);

        if (!visible) {
            return null;
        }

        return (
            <LogoStyles
                className={customCssClassName}
                selected={selected}
                hovered={hovered}
                onMouseLeave={node.actions.onMouseLeave()}
                onMouseMove={node.actions.onMouseMove()}
                data-qa={`${BASE_CLASS_NAME}--image-component`}
                src={logoSource}
                alt={accessibilityText}
                $width={width}
                onClick={node.actions.onClick()}
                ref={ref}
            />
        );
    },
);

Logo.splash = {
    related: {
        settings: React.lazy(() => import('./Logo.tools')),
    },
    defaultProps: {
        meta: {
            originalSrc: DEFAULT_LOGO_IMAGE,
            src: DEFAULT_LOGO_IMAGE,
            logoType: CONTENT_TYPE_DARK_LOGO,
            visible: true,
        },
        styles: {
            width: 176,
        },
    },
};

Logo.propTypes = {
    selected: PropTypes.bool.isRequired,
    hovered: PropTypes.bool.isRequired,
    meta: PropTypes.shape({
        src: PropTypes.string,
        logoType: PropTypes.string,
        accessibilityText: PropTypes.string,
        visible: PropTypes.bool,
    }).isRequired,
    styles: PropTypes.shape({
        width: PropTypes.number,
    }).isRequired,
};

export default Logo;
